import { Controller } from "@hotwired/stimulus"

// Gives this Turbo frame its src only once another frame has finished loading.
// For two lazy frames whose actions would fill the same cold cache entry in
// parallel: the second request then reads what the first one wrote instead of
// doing the same expensive work again (/my/hours_statistics: the Zeitkonto
// balance and the daily table's "Stand" column share one historic walk).
export default class extends Controller {
  static values = { frameId: String, src: String }

  static settledEvents = ["turbo:frame-load", "turbo:frame-missing", "turbo:fetch-request-error"]

  connect() {
    const frame = document.getElementById(this.frameIdValue)
    if (!frame || frame.hasAttribute("complete")) {
      this.load()
      return
    }

    this.frame = frame
    this.onSettled = () => this.load()
    this.constructor.settledEvents.forEach((name) => frame.addEventListener(name, this.onSettled))
  }

  disconnect() {
    this.stopListening()
  }

  // Eager, not lazy: a lazy frame only fetches when it scrolls into view, and one that was
  // already in view while it had no src never notices the src arriving.
  load() {
    this.stopListening()
    if (this.element.getAttribute("src")) return

    this.element.setAttribute("src", this.srcValue)
    this.element.setAttribute("loading", "eager")
  }

  stopListening() {
    if (!this.frame) return

    this.constructor.settledEvents.forEach((name) =>
      this.frame.removeEventListener(name, this.onSettled),
    )
    this.frame = null
  }
}
